export class StaffExcelFileImportModel {
    importacionId: number;
    primeraFila?: number;
    columnaClave?: number;
    tipoImportacion?: number;
    hojas?: number;
    camposImportacion: any; 
    mes: number;
    anyo: number;
    excelfile: any;
}
